<template>
  <div>
    <section class="orep-header mont" v-if="['individual-appraiser-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType ==='Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">
        <img v-else  src="../../../public/assets/images/OREPInsuranceShield_new.png" class="logo" alt="Logo">
        <span class="logo-text text-uppercase">CALIF. LIC. #0K99465</span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "individual-appraiser",
    computed: {

      axApplication() {
        return this.$store.state.axApplication.axApplication;
      },
      state() {
        return this.$store.state.axApplication;
      },
      errorMsg() {
        return this.$store.state.axApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/ax-application-amba' || first === '/portal/ax-application-amba/' || this.axApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/ax-application-realshield' || first === '/portal/ax-application-realshield/' || this.axApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
